export async function currentProjectUpdate(
  url: string,
  {
    arg,
  }: {
    arg: {
      project_id: number;
    };
  },
) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(arg),
  }).then((res) => res.json());
}
